import VideoThumbnailField from '../../components/VideoThumbnailField';
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  Autocomplete,
} from '@mui/material';
import ChannelBadge from '../../components/ChannelBadge';

export default function EditVideoDialog({
  open,
  thumbnail,
  setThumbnail,
  thumbnailBusy,
  setThumbnailBusy,
  onClose,
  editItem,
  editTitle,
  setEditTitle,
  editVideoContext,
  setEditVideoContext,
  editChannel,
  setEditChannel,
  editChannels,
  editChannelsLoading,
  editQrCode,
  setEditQrCode,
  qrCodes,
  qrCodesLoading,
  loadQrCodes,
  editError,
  setEditError,
  handleSaveEdit,
  savingEdit,
}) {
  return (
    <Dialog open={open} onClose={savingEdit || thumbnailBusy ? undefined : onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Edit Video</DialogTitle>
      <DialogContent>
        {editError && (
          <Alert severity='error' sx={{ mb: 2 }} onClose={() => setEditError(null)}>
            {editError}
          </Alert>
        )}
        {editItem && (
          <>
            <TextField
              margin='dense'
              fullWidth
              label='Title'
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              sx={{ mb: 2 }}
            />
            {open && (
              <VideoThumbnailField
                key={editItem?.id}
                videoId={editItem?.id}
                kind='sleep'
                title={editTitle}
                value={thumbnail}
                onChange={setThumbnail}
                disabled={savingEdit || thumbnailBusy}
                onBusyChange={setThumbnailBusy}
              />
            )}
            <TextField
              fullWidth
              multiline
              rows={2}
              label='Script context'
              value={editVideoContext}
              onChange={(e) => setEditVideoContext(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={qrCodes}
              getOptionLabel={(opt) => (opt ? opt.name : '')}
              isOptionEqualToValue={(a, b) => a && b && a.id === b.id}
              value={editQrCode}
              onChange={(_, val) => setEditQrCode(val)}
              loading={qrCodesLoading}
              filterOptions={(x) => x}
              onOpen={() => loadQrCodes()}
              renderInput={(params) => (
                <TextField {...params} label='QR Code' placeholder='None' />
              )}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={editChannels}
              getOptionLabel={(opt) =>
                (opt &&
                  (opt.profileNumber != null
                    ? `${opt.name} (#${opt.profileNumber})`
                    : opt.name)) ||
                ''
              }
              value={editChannel}
              onChange={(_, val) => setEditChannel(val)}
              loading={editChannelsLoading}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <ChannelBadge
                    channel={{
                      ...option,
                      name:
                        option.profileNumber != null
                          ? `${option.name} (#${option.profileNumber})`
                          : option.name,
                    }}
                  />
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label='Channel' required />
              )}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={savingEdit || thumbnailBusy}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleSaveEdit} disabled={savingEdit || thumbnailBusy}>
          {savingEdit ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
